module.exports = __webpack_public_path__ + "img/instagram_logo.cb116fe2.png";